import Vue from 'vue'
import Vuex from 'vuex'
import basicMutations from './store/basicMutations'
import {BlankState} from './store/stateChanges'
import charuzitActions from './store/charuzitActions'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: JSON.parse(JSON.stringify(BlankState)),
  mutations: {
    ...basicMutations,
   
  },
  actions: {
    ...charuzitActions,
   
  }
})

export default store
